import { stakeholderService } from '../services'

export default (id) => {
	return new Promise(resolve => {
		stakeholderService.getOauthConfig(id)
			.then(response => resolve(response.data))
	})
}
